import axios from "axios";
import info from "../store/modules/info";
import { Message, MessageBox, Loading } from "element-ui";
import { fetchEventSource } from "@microsoft/fetch-event-source";

let isDev = process.env.NODE_ENV === "development";
let base = "https://test-api.fjdaze.com/",
  requstUrl = "https://test-api.fjdaze.com/dkdcrm/";

if (location.host.includes("erp.fjdaze.com")) {
  base = "https://api.fjdaze.com/";
  requstUrl = "https://api.fjdaze.com/dkdcrm/v2/";
}

var ajax = axios.create({
  // baseURL: "http://192.168.0.17:4015/",
  baseURL: base,
  timeout: 0,
});

//ajax拦截器
ajax.interceptors.request.use(function (config) {
  if (config.data?._isSjzl) {
    config.data._isSjzl = undefined;
    config.baseURL = base;
    config.headers = {
      AccessToken: localStorage.getItem("erp_accessToken"),
    };
    return config;
  }

  if (/^\/((yhyl|pmcx|spbj)\/)|offers\/(index|spczgk|spczgl)/.test(info.state.routePath)) {
    if (!config.data?._isERP) {
      config.baseURL = base;
      config.headers = {
        AccessToken: localStorage.getItem("erp_accessToken"),
      };
      return config;
    }
  }

  config.baseURL = requstUrl;

  if (config.data?._isERP) {
    config.data._isERP = undefined;
  }

  let complete = config.data?.complete || false; // 是否自带域名
  if (complete) {
    config.baseURL = "";
  }

  var AccessToken = localStorage.getItem("dzyunaccess");
  if (AccessToken) {
    config.headers = {
      AccessToken: AccessToken,
    };
  }

  if (config.method == "get") {
    Object.assign(config.params, {
      Time: new Date().getTime(),
    });
  }
  return config;
});
ajax.interceptors.response.use(
  function (res) {
    let { data: reqData, baseURL } = res.config;
    let params = {};
    try {
      params = reqData ? JSON.parse(reqData) : {};
    } catch {
      params = {};
    }
    if (baseURL === requstUrl || params.complete) {
      if (res.data.Success && res.data.ErrorCode) {
        switch (res.data.ErrorCode) {
          case 200:
            return res.data.Data;
            break;
          case 4000:
            Message({
              type: "error",
              message: res.data.Message,
            });
            setTimeout(() => {
              location.href = "/#/index";
              return Promise.reject(res.data);
            }, 400);
            break;
          case 4005:
            Message({
              type: "error",
              message: res.data.Message,
            });
            setTimeout(() => {
              location.href = "/#/userLogin";
              return Promise.reject(res.data);
            }, 400);
            break;

          case 4006:
            // 去授权页
            location.href = "#/loginAuth";
            break;

          case 4007:
            // 未确认服务
            location.href = "#/useHelp";
            break;
          case 4008:
            // 1元服務過期
            location.href = "#/ExpiredHelp";
            break;
          default:
            Message({
              type: "error",
              message: res.data.Message,
            });
            let loadingInstance = Loading.service({});
            loadingInstance.close();
            return Promise.reject(res.data);
            break;
        }
      } else if (res.data.Success && !res.data.ErrorCode) {
        return res.data.Data;
      } else if (res.data.code && !res.data.ErrorCode) {
        return res.data;
      } else {
        let messageType = res.data.hasOwnProperty("Message");
        Message({
          type: "error",
          message: messageType ? res.data.Message : res.data.Tips,
        });
        return Promise.reject(messageType ? res.data.Message : res.data.Tips);
      }
    } else {
      return res.data;
    }
  },
  function (error) {}
);

// 文本流
ajax.eventSource = ({ url, errorCallBack, successCallBack, params }) => {
  const tokenName = window.dazeRunningConfing
    ? window.dazeRunningConfing.DAZE_APPLICATION_TOKEN_NAME || "accessToken"
    : "accessToken";
  const token = localStorage.getItem(tokenName);

  let baseUrl;
  if (process.env.NODE_ENV === "development") {
    baseUrl = "https://test-aicenter.fjdaze.cn/";
  } else if (location.host.indexOf("test.fjdaze.com") > -1) {
    baseUrl = "https://test-aicenter.fjdaze.cn/";
  } else {
    baseUrl = "https://aicenter.fjdaze.cn/";
  }

  url = baseUrl + url;
  let controller = new AbortController();

  let eventSource = fetchEventSource(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      AccessToken: token ?? "",
    },
    body: JSON.stringify(params),
    signal: controller.signal,
    onopen() {
      // console.log('open');
    },
    onmessage(event) {
      let data = JSON.parse(event.data);
      if (data.code === 200) {
        successCallBack && successCallBack(data, eventSource);
      } else {
        errorCallBack && errorCallBack(data, eventSource);
        controller.abort(); // 出错后不要重试
        // eventSource.close();
      }
    },
    onerror(error) {
      console.log("close", error);
      errorCallBack && errorCallBack({ code: 999, msg: "接口请求异常,请稍后再试！" }, eventSource);
      controller.abort(); //出错后不要重试
      // eventSource.close();
    },
  });
};
// proxy劫持 可以做 数据统计,数据转发
// ajax = new Proxy(ajax, {
//   get: function(target, key, proxy) {
//     var val = target[key];
//     return typeof val === "function"
//       ? function(...args) {
//           return Reflect.apply(target[key], target, args);
//         }
//       : val;
//   },
// });

export default ajax;
